// src/components/ProductCard.js
import React from 'react';
import { Card, CardMedia, CardContent, CardActions, Typography, Button, Box, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import { slugify } from '../utils/slugify';
import { getFullImageUrl } from '../utils/urlHelpers';

const ProductCard = ({ product }) => {
  const productUrl = `/product/${slugify(product.name)}-${product.id}`;

  // Ana görseli veya ilk görseli bul
  const mainImage =
    product.images?.find((img) => img.isMain)?.imageUrl ||
    product.images?.[0]?.imageUrl ||
    product.imageUrl;

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 24px rgba(240,138,12,0.18)',
        },
      }}
    >
      {mainImage ? (
        <CardMedia
          component="img"
          height="220"
          image={getFullImageUrl(mainImage)}
          alt={product.name}
          sx={{ objectFit: 'cover' }}
        />
      ) : (
        <Box
          sx={{
            height: 220,
            backgroundColor: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" color="text.disabled">
            Görsel yok
          </Typography>
        </Box>
      )}

      <CardContent sx={{ flexGrow: 1, pb: 1 }}>
        {product.oemCode && (
          <Chip
            label={`OEM: ${product.oemCode}`}
            size="small"
            sx={{ mb: 1, backgroundColor: '#fff3e0', color: '#e65100', fontSize: '0.7rem' }}
          />
        )}
        <Typography variant="h6" fontWeight={700} gutterBottom sx={{ fontSize: '1rem', lineHeight: 1.4 }}>
          {product.name}
        </Typography>
        {product.description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {product.description}
          </Typography>
        )}
      </CardContent>

      <CardActions sx={{ px: 2, pb: 2 }}>
        <Button
          variant="contained"
          size="small"
          component={Link}
          to={productUrl}
          fullWidth
          sx={{
            backgroundColor: '#f08a0c',
            '&:hover': { backgroundColor: '#d4780a' },
            borderRadius: 2,
            fontWeight: 600,
          }}
        >
          Detayları Gör
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
